import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AccountService } from "src/app/dashboard/services/account.service";
import Swal from "sweetalert2";
import { NbWindowRef, NbWindowService } from "@nebular/theme";

@Component({
  selector: "app-deposit",
  templateUrl: "./deposit.component.html",
  styleUrls: ["./deposit.component.css"],
})
export class DepositComponent implements OnInit {
  @ViewChild("companyBankDetailsTemplate")
  companyBankDetailsTemplate: TemplateRef<any>;

  localDepositManualForm: FormGroup;
  bitcoinDepositForm: FormGroup;
  selectedTab: number = 1;

  tradeAccounts: { login: number; type: string } = null;
  selectedFile: File = null;

  isManualDepositLoading: boolean = false;

  constructor(
    private account: AccountService,
    private windowService: NbWindowService
  ) {}
  ngOnInit() {
    this.localDepositManualForm = new FormGroup({
      login: new FormControl(null, [Validators.required]),
      depositType: new FormControl(null, [Validators.required]),
      amount: new FormControl(null, [Validators.required, Validators.min(1)]),
      depositNote: new FormControl(null, [
        Validators.required,
        Validators.maxLength(250),
      ]),
      depositProof: new FormControl(null, [Validators.required]),
    });

    this.bitcoinDepositForm = new FormGroup({
      login: new FormControl(null, [Validators.required]),
      amount: new FormControl(null, [Validators.required]),
    });

    this.getAccounts();
  }

  getAccounts() {
    this.account.getLiveAccountsList().subscribe((response) => {
      if (response.request_status) {
        this.tradeAccounts = response.data;
      }
    });
  }

  onSelectFile(event: { target: { files: File[] } }) {
    this.selectedFile = <File>event.target.files[0];
  }

  selectTab(tab: number) {
    this.selectedTab = tab;
  }

  localDeposit() {
    const fd = new FormData();
    fd.append("login", this.localDepositManualForm.value.login.login);
    fd.append("amount", this.localDepositManualForm.value.amount);
    fd.append("deposit_type", this.localDepositManualForm.value.depositType);
    fd.append("note", this.localDepositManualForm.value.depositNote);
    fd.append("file", this.selectedFile, this.selectedFile.name);

    this.uploadFile(fd);
  }

  uploadFile(fd: FormData) {
    this.isManualDepositLoading = true;
    this.account.depositManualLocal(fd).subscribe(
      (response) => {
        this.isManualDepositLoading = false;
        if (response.request_status) {
          Swal.fire("Manual Deposit Requested", "", "success");
          this.selectedFile = null;
          this.localDepositManualForm.reset();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        this.isManualDepositLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  companyBankDetailsTemplateWindow: NbWindowRef;
  openCompanyBankDetails() {
    this.companyBankDetailsTemplateWindow = this.windowService.open(
      this.companyBankDetailsTemplate,
      {
        title: "Company Bank Details",
        closeOnBackdropClick: false,
        closeOnEsc: false,
      }
    );
  }

  copyToClip(message: string) {
    navigator.clipboard.writeText(message).then(() => {
      Swal.fire("Wallet copy done");
    });
  }
}
